export class User {

    uid: number;
    // displayName: string;
    email: string;
    // photoURL: string;
    // date: string;
    // comment: string;
    constructor(user) {
        this.uid = user.uid;
        // this.displayName = user.displayName;
        this.email = user.email;
        // this.photoURL = user.photoURL;
        // this.date = ;
        // this.comment = user.comment;
    
    }
}  


// WEBPACK FOOTER //
// C:/Users/homePC/angular-comp/The-Top/src/app/class/user.ts